import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import Bread from "../../common/Bread";
import StandardTarrif from "../../components/StandardTarrif/StandardTarrif";
import { LangContext } from "../../context/LangContext";

function Staticpages() {
  const { slug } = useParams();
  const lang = useContext(LangContext);
  const nep = lang.state.np; // true if Nepali is active

  // Function to get the page title based on slug and language
  const getTitle = () => {
    switch (slug) {
      case "standard-tariff-charges":
        return nep ? "मानक ट्यारिफ शुल्क" : "Standard Tariff Charges";
      default:
        return nep ? "पृष्ठ फेला परेन" : "Page not Found";
    }
  };

  const breadcrumList = {
    image: "",
    title: getTitle(),
    l1: nep ? "होम" : "Home",
    l2:
      slug === "standard-tariff-charges"
        ? nep
          ? "मानक ट्यारिफ शुल्कहरू"
          : "Standard Tariff Charges"
        : "",
    l3: "",
  };

  return (
    <Bread data={breadcrumList}>
      <div>
        {slug === "standard-tariff-charges" ? (
          <StandardTarrif />
        ) : (
          <h1>{nep ? "पृष्ठ फेला परेन" : "Page Not Found"}</h1>
        )}
      </div>
    </Bread>
  );
}

export default Staticpages;
